<template>
  <div>
    <VTextField
      v-model="data.name[selectedLang]"
      :label="`${$t('forms.labels.name')} (${$t(`langs.${selectedLang}`)})`"
      :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
      outlined
      dataCy="nameVideoCategory"
      @input="updateData"
    />
    <VAutocomplete
      v-model="data.roles"
      itemText="label"
      itemValue="key"
      outlined
      :label="$t('forms.labels.roles')"
      :items="rolesList"
      :multiple="true"
      :rules="{ required: true }"
      @change="updateData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField';
import allRoles from '@/constants/roles';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VTextField,
        VAutocomplete,
    },
    props: {
        name: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
        roles: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        data: {
            name: { },
            roles: [],
        },
    }),
    computed: {
        ...mapGetters([
            'teamLangs',
            'teamMainLang',
            'selectedLang',
        ]),
        rolesList() {
            const excludedRoles = ['laboratoryManager', 'laboratoryMicrobiologist', 'laboratoryChemist', 'laboratoryTechnician'];
            const includedRoles = Object.values(allRoles).filter(role => !excludedRoles.includes(role.value));
            return Object.values(includedRoles).map(role => ({
                label: this.$t(`roles.${role.value}`),
                key: role.value,
            }));
        },
    },
    created() {
        if (this.isEdition) {
            this.data.name = this.name;
            this.data.roles = this.roles;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },

};
</script>
